import React, { useState } from 'react';
import styles from './Newsletter.module.css';
import WhiteSpace from '../../../WhiteSpace/WhiteSpace';
import axios from 'axios';

const Newsletter = () => {
    const [email, setEmail] = useState("");
    const [mensagem, setMensagem] = useState<string | null>(null);
    const [erro, setErro] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMensagem(null);
        setErro(null);

        if (!email) {
            setErro("Por favor insira um email válido.");
            return;
        }

        try {
            setLoading(true);
            const res = await axios.post("https://sazuli.pt/api/newsletter", { email });

            if (res.data.success) {
                setMensagem(res.data.message);
                setEmail(""); // limpa o input
            }
        } catch (err: any) {
            if (err.response?.status === 409) {
                setErro("Este email já está subscrito.");
            } else {
                setErro("Ocorreu um erro. Tente novamente mais tarde.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <span className={styles.title}>Receba ideias<br />Crie possibilidades</span>

                <form className={styles.form} onSubmit={handleSubmit}>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="example@sazuli.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? "A enviar..." : "Subscreve"}
                    </button>
                </form>

                {mensagem && <p className={styles.success}>{mensagem}</p>}
                {erro && <p className={styles.error}>{erro}</p>}
            </div>
        </div>
    );
};

export default Newsletter;